import { Directive, input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[header-right]',
})
export class HeaderRightDirective {
    name = input.required<string>({ alias: 'header-right' });

    constructor(public template: TemplateRef<any>) {}
}
